<template>
  <div class="flex flex-col justify-center sm:ml-0">
    <label class="inline-block font-medium mb-2">
      Where do you want to go?
    </label>
    <custom-select
      class="select-country-collection"
      :placeholder="placeholder"
      prevIcon="/img/sprite.svg#ic_location"
      v-model="destination"
      :options="destinationOptions"
    />
  </div>
</template>

<script>
import CustomSelect from "./CustomSelect";
import orderBy from "lodash/orderBy";

export default {
  components: {
    CustomSelect,
  },
  props: {
    country: {
      type: Object,
      default: null,
    },
    countries: {
      type: Array,
      default: [],
    },
  },
  data() {
    let placeholder = "Anywhere";
    if (window.matchMedia("(max-width: 600px)").matches) {
      placeholder = "Choose a destination";
    }

    let destinationOptions = this.countries.map((_c) => {
      return { label: _c.title, value: _c.slug, code: _c.code };
    });

    destinationOptions = orderBy(destinationOptions, ["label"], ["asc"]);
    destinationOptions.unshift({ label: "Anywhere", value: 0, code: 0 });

    return {
      destinationOptions,
      placeholder,
    };
  },
  computed: {
    destination: {
      get() {
        if (this.country) {
          return this.country.value;
        }
        return null;
      },
      set(val) {
        const country = this.destinationOptions.find((_d) => _d.value === val);
        this.$emit("set-destination", country);
      },
    },
  },
};
</script>

<style scoped>
::v-deep .input {
  padding-left: 50px;
  border-radius: 0.5rem;
  border: 1px solid #000;
}

::v-deep ::placeholder {
  color: #5e5f5f !important;
  opacity: 1;
}

::v-deep .search-icon {
  position: absolute;
  top: 50%;
  left: 15px;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
</style>
